import { APPOINTMENT_REDIRECT_TYPE } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/constants'
import type {
  AppointmentPlaceType,
  LpuDoctorMinPrices,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

/**
 * `type` для формы записи: клуб, дом, телемед или обычный приём.
 */
export default function getAppointmentRedirectType(
  placeType: AppointmentPlaceType,
  minPrices?: LpuDoctorMinPrices | null,
): string {
  if (placeType === 'clinic' && typeof minPrices?.tab_min_club_price === 'number') {
    return APPOINTMENT_REDIRECT_TYPE.CLUB
  }

  if (placeType === 'home') {
    return APPOINTMENT_REDIRECT_TYPE.HOME
  }

  if (placeType === 'telemed') {
    if (
      typeof minPrices?.tab_min_price_telemed !== 'number'
      && typeof minPrices?.tab_min_price_telemed_medtochka === 'number'
    ) {
      return APPOINTMENT_REDIRECT_TYPE.TELEMED_MT
    }

    return APPOINTMENT_REDIRECT_TYPE.TELEMED
  }

  return APPOINTMENT_REDIRECT_TYPE.DEFAULT
}
